import { useContext, useRef, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { useNavigate } from "react-router";
import { MFAForm } from "./MFAForm";
import { ErrorsDisplay } from "../Shared/Error";
import { LoginResponseModel } from "../../../apis/ApisAuth";
import { LogonStatus } from "../../Variables";

export type LoginFormProps = {
    onCompleteCallback: (doLogic : boolean) => void,
    redirectToParams: string,
    showHeaderTitle: boolean,
}

export function LoginForm(props: LoginFormProps) {
    const app = useContext(AppContext);
    const [showLoginArea, setShowLoginArea] = useState<boolean>(true);
    const [showMFAArea, setShowMFAArea] = useState<boolean>(false);
    const [inputUsername, setInputUsername] = useState<string>('');
    const [inputPassword, setInputPassword] = useState<string>('');
    const [loginResponse, setLoginResponse] = useState<LoginResponseModel>(null);

    const [error, setErrors] = useState<string[]>([]);
    const [tries, setTries] = useState<number>(0);

    const inputUsernameRef = useRef<HTMLInputElement>(null);
    const inputPasswordRef = useRef<HTMLInputElement>(null);

    let navigate = useNavigate();
    const resetInputs = () => {
        setInputUsername('');
        setInputPassword('');
    }

    const tryLogin = async () => {
        let errors: string[] = [];
        if (inputPassword != '' && inputUsername != '' && inputUsername.length > 0 && inputPassword.length > 0) {
            var res = await app.logInUser(inputUsername, inputPassword);
            setLoginResponse(res);
            if (res.Status == LogonStatus.PASS) {
                inputPasswordRef?.current?.classList.remove("is-valid");
                inputPasswordRef?.current?.classList.remove("is-invalid");
                inputUsernameRef?.current?.classList.remove("is-valid");
                inputUsernameRef?.current?.classList.remove("is-invalid");

                if (res.MFAPrompt) {
                    setShowMFAArea(true);
                    setShowLoginArea(false);
                    setInputPassword('');
                }
                else {
                    setShowMFAArea(false);
                    setShowLoginArea(true);
                    resetInputs();
                    props.onCompleteCallback(true);
                }
            }
            else {
                setInputPassword('');
                errors = (["Invalid user name or password"]);
            }
        }
        else {
            if (inputPassword == '' || inputPassword.length == 0) {
                errors = ([...errors, "Please provide a password"]);
                inputPasswordRef?.current?.classList.add("is-invalid");
                inputPasswordRef?.current?.classList.remove("is-valid");
            }
            else {
                inputPasswordRef?.current?.classList.remove("is-invalid");
                inputPasswordRef?.current?.classList.add("is-valid");
            }

            if (inputUsername == '' || inputUsername.length == 0) {
                errors = ([...errors, "Please provide a username"]);
                inputUsernameRef?.current?.classList.add("is-invalid");
                inputUsernameRef?.current?.classList.remove("is-valid");
            } else {
                inputUsernameRef?.current?.classList.remove("is-invalid");
                inputUsernameRef?.current?.classList.add("is-valid");
            }
        }

        if (errors.length > 0)
            setTries(tries + 1);

        setErrors(errors);
    }

    return (
        <>
            {props.showHeaderTitle &&
                <div className="d-flex justify-content-center">
                    <div className="">
                        <h3 className="text-alt-or-contrast text-center" id="offcanvasNavbarLabel">Login</h3>
                        <hr className="ShortBlock" />
                    </div>
                </div>}

            <div className="d-flex flex-column gap-2 mt-3" role="login">
                <ErrorsDisplay errors={error}>
                    {tries > 3 &&
                        <div className="mt-2">If you continue to have any issues please contact <a className="text-danger" href='mailto:support@allhires.com'>support@allhires.com</a> for assistance</div>
                    }
                </ErrorsDisplay>

                {(!app.userLoggedIn && showLoginArea) && <>
                    <div className="col-auto">
                        <label htmlFor="usernameontrol" className="form-label-alt">Username</label>
                        <input ref={inputUsernameRef} placeholder="Username" id="usernameontrol" aria-label="Username" className="form-control"
                            value={inputUsername}
                            type="text"
                            onChange={t => {
                                setInputUsername(t.currentTarget.value);
                                inputUsernameRef?.current?.classList.remove("is-valid");
                                inputUsernameRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            Please provide a username
                        </div>
                    </div>

                    <div className="col-auto">
                        <label htmlFor="passwordControl" className="form-label-alt">Password</label>
                        <input ref={inputPasswordRef} placeholder="Password" id="passwordControl" aria-label="Password" className="form-control"
                            value={inputPassword}
                            type="password"
                            onChange={t => {
                                setInputPassword(t.currentTarget.value);
                                inputPasswordRef?.current?.classList.remove("is-valid");
                                inputPasswordRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            Please provide a password
                        </div>
                    </div>

                    <a className="link-alt-or-contrast align-self-end mb-2" href="#"
                        onClick={e => {
                            document.getElementById("close-righthand-menu")?.click();
                            props.onCompleteCallback(false);
                            navigate('/ForgotPassword');
                        }}><u>Forgot password / username</u></a>

                    <button className="btn btn-secondary" type="submit" onClick={e => {
                        e.preventDefault();
                        tryLogin();
                    }}>Log In</button>

                    <div className="d-flex flex-column gap-3 mt-3">
                        <div className="align-self-center">Don’t have an account? <a className="link-alt-or-contrast"
                            href="#"
                            onClick={e => {
                                props.onCompleteCallback(false);
                                document.getElementById("close-righthand-menu")?.click();
                                navigate(`/Register${props?.redirectToParams}`);
                            }}><u><b>Register</b></u></a>
                        </div>
                        <div className="align-self-center">Are you an agent? <a className="link-alt-or-contrast" href="../Agency/"><u><b>Agent portal</b></u></a></div>
                    </div>
                </>}

                {(!app.userLoggedIn && showMFAArea) && <>
                    <MFAForm setErrorCallback={setErrors} onCompleteCallback={props.onCompleteCallback} baseState={loginResponse} inputUsername={inputUsername} />
                </>}
            </div>
        </>
    );
}